
export default {
    drawer: true, 
    responsive: false,
    systemlogo: '../logo.png',
    applogo: '../logo2.png',
    is_logged: false,
    show_alert: false,
    alert_color: "secondary",
    alert_text: "No message",
    todays_transactions: [],
    qued_transactions: [],
    month_sales: {},
    credits: {},
    month_daily_sales:[],
    todays_fishcars:[],
    supplies: [],
    sequence: 0,
    fishcar_daily_sales:[],
    midprice: 0,
    kilos_to_distribute: 0,
    income_source_summary: [],
    sales_summary: [],
  }
  